import { Col, DisplayData, KeycloakService, Row } from '@elotech/components';
import { ProcessSelect } from '@elotech/react-components';
import { ProcessoDigitalService } from 'common/service';
import { ProcessoDigitalDTO } from 'common/type/ProcessoDigitalDTO';
import { useEffect, useState } from 'react';

const getTokenPromise = async (): Promise<string> => {
  await KeycloakService.refreshToken({});
  return KeycloakService.getToken() || '';
};

type Props = {
  value?: string;
  onChange: (value: string) => void;
};

export const ProcessoDigitalSelect = ({ value, onChange }: Props) => {
  const [processoDigital, setProcessoDigital] = useState<ProcessoDigitalDTO>();

  useEffect(() => {
    if (value) {
      ProcessoDigitalService.findById(value).then(({ data }) => {
        setProcessoDigital(data);
      });
    } else {
      setProcessoDigital(undefined);
    }
  }, [value]);

  return (
    <>
      <ProcessSelect
        tokenPromise={getTokenPromise}
        value={value || ''}
        multiple={false}
        valueChange={onChange}
        placeholder="Selecione um processo"
      />
      {processoDigital && (
        <div className="display-data border small">
          <Row>
            <Col sm={2} md={2}>
              <DisplayData title="Número">{processoDigital.numero}</DisplayData>
            </Col>
            <Col sm={2} md={2}>
              <DisplayData title="Ano">{processoDigital.ano}</DisplayData>
            </Col>
            <Col sm={4} md={4}>
              <DisplayData title="Título">{processoDigital.titulo}</DisplayData>
            </Col>
            <Col sm={4} md={4}>
              <DisplayData title="Assunto">
                {processoDigital.assunto}
              </DisplayData>
            </Col>
          </Row>
          <Row>
            <Col sm={6} md={6}>
              <DisplayData title="Situação">
                {processoDigital.situacao}
              </DisplayData>
            </Col>
            <Col sm={6} md={6}>
              <DisplayData title="Tipo">{processoDigital.tipo}</DisplayData>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
